import { createDerivedWritableAtom } from '../../../utils';
import { visitorAtom } from '../../state';

export const admissionAttemptsAtom = createDerivedWritableAtom(visitorAtom, 'admissionAttempts');

export const joinAttemptsAtom = createDerivedWritableAtom(visitorAtom, 'joinAttempts');

export const isAdmissionModalOpenAtom = createDerivedWritableAtom(visitorAtom, 'isAdmissionModalOpen');

export const isProviderNotHereModalOpenAtom = createDerivedWritableAtom(visitorAtom, 'isProviderNotHereModalOpen');

export const admissionTimeAtom = createDerivedWritableAtom(visitorAtom, 'admissionTime');
